<!------------------------------------------- template ------------------------------------------->
<template>
  <!-- 页脚 -->
  <div class="foot_box">
    <div class="foot_container">
      <ul v-for="(item,index) in menuList" :key="index">
        <li class="foot_title">{{item.title}}</li>
        <li class="foot_item" v-for="(innerItem,i) in item.list" :key="i"><a href="javascript:;">{{innerItem.label}}</a></li>
      </ul>
    </div>
  </div>
</template>

<!-------------------------------------------- script -------------------------------------------->
<script>
export default {
  name: '',
  components: {},

  data() {
    return {
      menuList: [
        {
          title: '系统平台',
          list: [
            {
              label: '市场运营管理平台'
            },
            {
              label: '商户进销存平台'
            }, {
              label: '支付结算系统'
            }, {
              label: '物联网平台'
            }, {
              label: '无人值守地磅'
            }, {
              label: '电子会员系统'
            }, {
              label: '电子商城管理平台'
            }
          ]
        }, {
          title: '市场智能硬件',
          list: [
            {
              label: '智能PDA'
            },
            {
              label: '停车收费系统'
            }, {
              label: '智能水电表'
            }, {
              label: 'LED大数据屏'
            }, {
              label: '信息查询触摸一体机'
            }, {
              label: '客流采集仪'
            }, {
              label: '食品安全检测设备'
            }
          ]
        },
        {
          title: '商铺智能硬件',
          list: [
            {
              label: '智能电子秤（台秤、桌秤）'
            },
            {
              label: '智能手持POS'
            }, {
              label: '智能手持PDA'
            }, {
              label: '语音播报打印机'
            }
          ]
        },
        {
          title: '行业解决方案',
          list: [
            {
              label: '智慧农批解决方案'
            },
            {
              label: '智慧农贸解决方案'
            }, {
              label: '智慧园区解决方案'
            }
          ]
        }
      ]
    }
  },

  /* 一.生命周期函数 */
  created() {
  },

  /* 二.监控函数 */
  watch: {},

  computed: {},

  /* 三.内部功能函数 */
  methods: {}
}
</script>

<!--------------------------------------------- style -------------------------------------------->
<style scoped>
.foot_box {
  width: 100%;
  height: 341px;
  margin: 0 auto;
  background-image: url("../../assets/img/bottom@2x.png");
  background-repeat: no-repeat;
  background-size: cover;
  border-bottom: 1px solid #ccc;
}

.foot_container {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  padding-top: 40px;
  box-sizing: border-box;
}

.foot_title{
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}

.foot_item{
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 16px;
}

.foot_item a{
  color: #333333;
}

.foot_item a:hover{
  color: #1958C4;
}

.foot_container ul{
  width: 300px;
}
</style>
